
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"view-hide"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#a)","fill-rule":"evenodd","clip-rule":"evenodd","fill":"currentColor"}},[_c('path',{attrs:{"d":"M18.394 1.49a.609.609 0 01-.018.87L2.751 17.129a.632.632 0 01-.884-.018.609.609 0 01.019-.87L17.51 1.471a.632.632 0 01.884.019zm-2.44 4.887a.631.631 0 01.874-.134 17.668 17.668 0 012.655 2.344l.002.003a1.959 1.959 0 010 2.65l-.002.002c-2.183 2.366-5.804 4.885-9.485 4.827a9.072 9.072 0 01-2.712-.396.614.614 0 01-.412-.77.627.627 0 01.782-.405 7.809 7.809 0 002.34.34h.015c3.15.053 6.454-2.155 8.546-4.422a.743.743 0 000-1.001 16.434 16.434 0 00-2.466-2.178.61.61 0 01-.137-.86zM10 3.763a8.709 8.709 0 012.16.25c.335.081.54.415.456.745a.626.626 0 01-.758.449 7.442 7.442 0 00-1.853-.213h-.017c-3.094-.051-6.408 2.108-8.543 4.42a.743.743 0 000 1.001 16.45 16.45 0 002.086 1.896.61.61 0 01.11.864.632.632 0 01-.877.109 17.87 17.87 0 01-2.244-2.04l-.003-.004A1.963 1.963 0 010 9.915c0-.49.184-.961.517-1.325l.002-.002c2.23-2.416 5.86-4.88 9.481-4.825z"}}),_c('path',{attrs:{"d":"M9.997 7.453a2.533 2.533 0 00-1.767.72 2.428 2.428 0 00-.732 1.74.62.62 0 01-.625.616.62.62 0 01-.625-.615 3.672 3.672 0 011.098-2.611 3.754 3.754 0 011.216-.8 3.8 3.8 0 011.436-.281.62.62 0 01.625.615.62.62 0 01-.626.616zM13.125 9.3a.62.62 0 01.625.615c0 .485-.097.965-.285 1.414a3.688 3.688 0 01-.813 1.198A3.798 3.798 0 0110 13.609a.62.62 0 01-.625-.616c0-.34.28-.615.625-.615a2.534 2.534 0 001.768-.722 2.43 2.43 0 00.732-1.741c0-.34.28-.615.625-.615z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    